import React from 'react';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import AutoGraphRoundedIcon from '@mui/icons-material/AutoGraphRounded';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import BookmarksRoundedIcon from '@mui/icons-material/BookmarksRounded';
import BookmarksOutlinedIcon from '@mui/icons-material/BookmarksOutlined';
import AddTaskRoundedIcon from '@mui/icons-material/AddTaskRounded';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import type {MenuItem} from './types/types';

export const MenuItems: MenuItem[] = [
  {
    id: 1,
    label: 'Dashboard',
    menuKey: "DASHBOARD",
    icon: <DashboardOutlinedIcon />,
    activeIcon: <DashboardRoundedIcon color="inherit" />,
    link: '/dashboard',
    hasSubmenu: false,
  },
  {
    id: 2,
    label: 'Reports',
    menuKey:'REPORTS',
    icon: <AutoGraphRoundedIcon />,
    activeIcon: <AutoGraphRoundedIcon color="inherit" />,
    link: '/reports',
    hasSubmenu: true,
    subMenu: [
      {
        id: 21,
        label: 'Title Dashboard',
        link: '/reports/title-dashboard',
        menuFeatureKey:'TITLEDASHBOARD'
      },
      {
        id: 22,
        label: 'Geographic Dashboard',
        link: '/reports/geographic-dashboard',
        menuFeatureKey:'GEOGRAPHICDASHBOARD'
      }
      
    ],
  },
  {
    id: 3,
    label: 'Settings',
    menuKey:'SETTINGS',
    icon: <SettingsOutlinedIcon />,
    activeIcon: <SettingsOutlinedIcon color="inherit" />,
    link: '/settings',
    hasSubmenu: true,
    subMenu: [
      {
        id: 31,
        label: 'Manage Users',
        link: '/settings/manage-users',
        menuFeatureKey:'MANAGEUSERS'
      },
      {
        id: 32,
        label: 'Manage Roles',
        link: '/settings/manage-roles',
        menuFeatureKey:'MANAGEROLES'
      },
    ],
  },
  {
    id: 4,
    label: 'Saved Reports',
    menuKey:'SAVEDREPORTS',
    icon: <BookmarksOutlinedIcon />,
    activeIcon: <BookmarksRoundedIcon color="inherit" />,
    link: '/savedreports',
    hasSubmenu: false,
  },
  {
    id: 5,
    label: 'Counts and Orders',
    menuKey:'COUNTANDORDERS',
    icon: <AddTaskRoundedIcon />,
    activeIcon: <AddTaskRoundedIcon color="inherit" />,
    link: '/manage-jobs',
    hasSubmenu: false,
  },
];